import React, { useState } from "react";
import TermsAndConditions from "./TermsAndConditions";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signInWithCustomToken,
} from "firebase/auth";
import { auth } from "../Config/firebase";
import axios from "axios";
import config from "../Config/config";

import logo from "../../assets/logo.png";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import ToastAlert, { showToast } from "../Common/ToastAlert";

const dialogPaperSx = {
  borderRadius: "1.25rem",
  overflow: "hidden",
  border: "1px solid rgba(148,163,184,0.4)",
  boxShadow: "0 18px 45px rgba(15,23,42,0.18)",
};

const LandingPage = () => {
  const [showLogin, setShowLogin] = useState(true);


  return (
    <div className="flex w-screen h-screen bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#020617] text-gray-800 flex-col md:flex-row overflow-scroll">
      <ToastAlert />

      {/* Left side: Information about Listernaut */}
      <div className="flex flex-col justify-center items-center w-full md:w-1/2 h-full bg-gradient-to-br from-white via-slate-50 to-indigo-50 p-6 md:p-10 relative">
        <div className="absolute inset-0 pointer-events-none opacity-40">
          <div className="absolute -top-24 -left-24 w-64 h-64 bg-indigo-200 rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-0 w-72 h-72 bg-purple-200 rounded-full blur-3xl" />
        </div>

        <div className="relative z-10 flex flex-col items-center text-center max-w-xl">
          <img
            src={logo}
            className="w-[170px] h-[170px] md:w-[200px] md:h-[200px] mb-4 md:mb-6"
            alt="Listernaut Logo"
          />

          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-100 text-indigo-700 text-[0.7rem]  uppercase tracking-[0.15em] mb-2">
            AI-Powered Cataloging
          </span>

          <h1 className="text-3xl md:text-4xl  text-[#111827] mb-3">
            AI Cataloging Software
          </h1>

          <p className="text-base md:text-lg text-slate-600 leading-relaxed mb-4 md:mb-6">
            Dramatically increase cataloging productivity with enhanced AI product listing.
            Create an account for free and only pay for what you use when your product is
            ready to list and sell. List products fast and export them to just about any
            platform quickly!
          </p>

          <div className="flex flex-col gap-3 w-full">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-left">
              <div className="bg-white/80 backdrop-blur-md border border-slate-200 rounded-2xl p-3 shadow-sm flex flex-col gap-1">
                <span className="text-xs  text-slate-500 uppercase tracking-wide">
                  10x Faster
                </span>
                <span className="text-sm text-slate-700">
                  AI-driven titles, descriptions, and attributes in seconds.
                </span>
              </div>
              <div className="bg-white/80 backdrop-blur-md border border-slate-200 rounded-2xl p-3 shadow-sm flex flex-col gap-1">
                <span className="text-xs  text-slate-500 uppercase tracking-wide">
                  Multi-Platform
                </span>
                <span className="text-sm text-slate-700">
                  Export to AuctionFlex, Wavebid, Shopify, and more.
                </span>
              </div>
              <div className="bg-white/80 backdrop-blur-md border border-slate-200 rounded-2xl p-3 shadow-sm flex flex-col gap-1">
                <span className="text-xs  text-slate-500 uppercase tracking-wide">
                  Pay As You Go
                </span>
                <span className="text-sm text-slate-700">
                  Free to get started. Only pay when you&apos;re ready to list.
                </span>
              </div>
            </div>

            <p className="text-sm md:text-base  text-indigo-700 mt-1">
              Level up, with Listernaut.
            </p>
          </div>
        </div>
      </div>

      {/* Vertical separator line */}
      <div className="hidden md:block w-px h-full bg-slate-800/60" />

      {/* Right side: Login / Signup card */}
      <div className="flex flex-col justify-center items-center w-full md:w-1/2 h-full px-4 sm:px-6 lg:px-10 py-6 relative">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-10 right-10 w-40 h-40 bg-indigo-500/40 rounded-full blur-3xl" />
          <div className="absolute bottom-10 left-0 w-64 h-64 bg-purple-500/40 rounded-full blur-3xl" />
        </div>

        <div className="relative z-10 w-full max-w-md">
          <div className="text-center mb-4">
            <span onClick={() => setShowLogin(false)} className="inline-flex items-center px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-400/40 text-emerald-200 text-[0.65rem]  uppercase tracking-[0.18em]">
              Signup for Free Trial +100 tokens
            </span>
            <h2 className="mt-2 text-2xl md:text-3xl  text-slate-50">
              Start cataloging with AI today
            </h2>
            <p className="mt-1 text-sm text-slate-300">
              No setup fees. No long-term contracts.
            </p>
          </div>

          <div className="bg-slate-900/80 backdrop-blur-xl border border-slate-700/70 rounded-2xl shadow-2xl p-5 sm:p-6">
            {/* Toggle */}
            <div className="flex bg-slate-800 rounded-full p-1 mb-5">
              <button
                type="button"
                className={`flex-1 px-4 py-2 text-sm  rounded-full transition-all ${showLogin
                  ? "bg-gradient-to-r from-indigo-500 to-indigo-400 text-white shadow-md"
                  : "text-slate-300 hover:text-white"
                  }`}
                onClick={() => setShowLogin(true)}
              >
                Login
              </button>
              <button
                type="button"
                className={`flex-1 px-4 py-2 text-sm  rounded-full transition-all ${!showLogin
                  ? "bg-gradient-to-r from-indigo-500 to-indigo-400 text-white shadow-md"
                  : "text-slate-300 hover:text-white"
                  }`}
                onClick={() => setShowLogin(false)}
              >
                Signup
              </button>
            </div>

            {/* Form */}
            <div className="transition-all duration-300 ease-in-out transform">
              {showLogin ? <StyledLogin /> : <StyledSignup />}
            </div>

            {!showLogin && (
              <p className="mt-4 text-[0.75rem] text-slate-400 text-center">
                By signing up, you agree to our{" "}
                <span className="text-indigo-300 ">
                  Terms & Conditions
                </span>
                .
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// ---------------------- LOGIN ----------------------

const StyledLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [, setError] = useState("");
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const idToken = await userCredential.user.getIdToken();

      const response = await axios.post(`${config.API_BASE_URL}/login`, {
        email,
        idToken,
      });
      console.log(response)
      localStorage.setItem("userId", response.data.user.id);
      localStorage.setItem("email", response.data.user.email);
      localStorage.setItem("username", response.data.user.username);
      localStorage.setItem("hibid", String(response?.data?.user?.hibid === true));
      setError("");
      showToast("Logged in successfully.", "success");
    } catch (err) {
      console.error("Login error:", err);
      setError("Failed to log in. Please check your credentials.");
      showToast("Failed to log in. Please check your credentials.", "error");
    }
  };

  const handleForgotPassword = async () => {
    if (!forgotEmail) {
      showToast("Please enter your email.", "warning");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, forgotEmail);
      showToast(
        "Password reset link has been sent. Check your email.",
        "success"
      );
      setForgotPasswordOpen(false);
      setForgotEmail("");
    } catch (err) {
      console.error("Forgot password error:", err);
      showToast("Failed to send password reset email.", "error");
    }
  };

  return (
    <>
      <form className="flex flex-col space-y-4" onSubmit={handleLogin}>
        <div>
          <label className="block text-slate-200  mb-1 text-sm">
            Email
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2.5 rounded-full border border-slate-600 bg-slate-900/60 text-slate-50 placeholder-slate-400 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/50 outline-none text-sm transition"
            placeholder="you@example.com"
          />
        </div>
        <div>
          <label className="block text-slate-200  mb-1 text-sm">
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2.5 rounded-full border border-slate-600 bg-slate-900/60 text-slate-50 placeholder-slate-400 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/50 outline-none text-sm transition"
            placeholder="Enter your password"
          />
        </div>
        <div className="text-right">
          <button
            type="button"
            className="text-xs text-indigo-300 hover:text-indigo-200 hover:underline focus:outline-none"
            onClick={() => setForgotPasswordOpen(true)}
          >
            Forgot Password?
          </button>
        </div>
        <button
          type="submit"
          className="w-full px-4 py-2.5 mt-2 bg-gradient-to-r from-indigo-500 to-indigo-400 text-white rounded-full  text-sm hover:from-indigo-400 hover:to-indigo-300 shadow-md hover:shadow-lg transition-all"
        >
          Login
        </button>
      </form>

      {/* Forgot Password Modal */}
      <Dialog
        open={forgotPasswordOpen}
        onClose={() => setForgotPasswordOpen(false)}
        PaperProps={{ sx: dialogPaperSx }}
      >
        <DialogTitle
          sx={{
            px: 3,
            py: 2.5,
            pb: 1.5,
            fontWeight: 700,
            fontSize: "1.05rem",
            color: "#ffffff",
            background: "linear-gradient(to right, #333999, #5555bb)",
            borderTopLeftRadius: "1.25rem",
            borderTopRightRadius: "1.25rem",
          }}
        >
          Reset Password
        </DialogTitle>
        <DialogContent
          sx={{
            px: 3,
            pt: 2.5,
            pb: 2,
            background:
              "linear-gradient(to bottom right, #f9fafb, #edf2ff, #eef2ff)",
          }}
        >
          <TextField
            fullWidth
            label="Enter your email"
            value={forgotEmail}
            onChange={(e) => setForgotEmail(e.target.value)}
            variant="outlined"
            margin="normal"
            size="small"
          />
          <Typography
            variant="body2"
            sx={{ color: "#4b5563", fontSize: "0.85rem", mt: 1 }}
          >
            A password reset link will be sent to your email.
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            py: 2,
            backgroundColor: "rgba(255,255,255,0.95)",
            borderTop: "1px solid rgba(226,232,240,0.9)",
          }}
        >
          <Button
            onClick={() => setForgotPasswordOpen(false)}
            sx={{
              textTransform: "none",
              borderRadius: "999px",
              px: 2.5,
              fontWeight: 500,
              color: "#4b5563",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleForgotPassword}
            sx={{
              textTransform: "none",
              borderRadius: "999px",
              px: 2.75,
              fontWeight: 600,
              background: "linear-gradient(to right, #333999, #5555bb)",
              color: "#ffffff",
              boxShadow: "0 10px 25px rgba(15,23,42,0.25)",
              "&:hover": {
                background: "linear-gradient(to right, #2a2a7a, #4444aa)",
                boxShadow: "0 12px 30px rgba(15,23,42,0.35)",
              },
            }}
          >
            Send Reset Link
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

// ---------------------- SIGNUP ----------------------

const StyledSignup = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [signupType, setSignupType] = useState("");
  const [heardFrom, setHeardFrom] = useState("");
  const [referralSourceName, setReferralSourceName] = useState("");
  const [error, setError] = useState("");
  const [termsOpen, setTermsOpen] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isSigningUp, setIsSigningUp] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();

    // Prevent double-submit
    if (isSigningUp) return;

    if (!email || !password || !name) {
      setError("All required fields must be filled.");
      showToast("Please fill in all required fields.", "warning");
      return;
    }
    if (heardFrom === "Referral" && !referralSourceName) {
      setError("Please enter the referral source name.");
      showToast("Please enter the referral source name.", "warning");
      return;
    }
    if (!termsAccepted) {
      setError("You must accept the Terms & Conditions before signing up.");
      showToast("Please accept Terms & Conditions to continue.", "warning");
      return;
    }

    setIsSigningUp(true);

    try {
      // Backend creates Firebase Auth user + Firestore entry and returns a customToken
      const signupResp = await axios.post(`${config.API_BASE_URL}/signup`, {
        email,
        username: name,
        password,
        phone,
        company,
        signupType,
        heardFrom,
        referralSourceName: heardFrom === "Referral" ? referralSourceName : "",
      });

      const { userId, customToken, hibid } = signupResp.data || {};

      if (customToken) {
        // Sign in immediately using custom token
        await signInWithCustomToken(auth, customToken);
      } else {
        // Fallback: user can log in with email/password after signup
        console.warn(
          "No customToken returned from backend signup; user will need to log in."
        );
      }

      // Persist identity (use backend userId if present)
      if (userId) localStorage.setItem("userId", userId);
      localStorage.setItem("email", email);
      localStorage.setItem("username", name);
      localStorage.setItem("hibid", String(hibid === true));
      setError("");

      const logoUrl =
        "https://storage.googleapis.com/listalotimages/emailtemplates/logo.png";
      const htmlTemplate = `
<!DOCTYPE html>
<html lang="en" xmlns="http://www.w3.org/1999/xhtml"
      xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:v="urn:schemas-microsoft-com:vml">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width,initial-scale=1">
  <meta name="x-apple-disable-message-reformatting">
  <title>Welcome to Listernaut!</title>
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&family=Roboto:wght@400;500&display=swap" rel="stylesheet">
  <style>
    body { margin:0; padding:0; background-color:#f0f4f7; }
    table, td, div, h1, p { font-family:'Roboto',Arial,sans-serif; color:#333; }
    h1, h2, h3 { font-family:'Poppins',Arial,sans-serif; font-weight:700; color:#2c3e50; }
    a { text-decoration:none; }
    .button-link {
      background-color:#007bff !important;
      color:#ffffff !important;
      text-decoration:none;
      padding:14px 28px;
      border-radius:6px;
      display:inline-block;
      font-size:16px;
      font-weight:600;
      font-family:'Poppins',Arial,sans-serif;
    }
    .two-column { font-size:0; text-align:center; }
    .two-column .column { width:100%; max-width:260px; display:inline-block; vertical-align:top; text-align:center; }
    @media screen and (max-width:600px){
      .container { width:100%!important; border-radius:0!important; }
      .content-padding { padding:30px 20px!important; }
      h1 { font-size:26px!important; line-height:34px!important; }
      h2 { font-size:22px!important; line-height:30px!important; }
      .two-column .column { max-width:100%!important; display:block!important; width:100%!important; margin-bottom:25px!important; }
      .button-link { width:85%!important; padding:14px 0!important; }
    }
  </style>
</head>

<body style="margin:0;padding:0;background-color:#f0f4f7;">
  <table role="presentation" style="width:100%;border-collapse:collapse;background:#f0f4f7;">
    <tr><td align="center" style="padding:20px 0;">
      <table class="container" role="presentation" style="width:600px;background:#fff;border-radius:12px;box-shadow:0 8px 20px rgba(0,0,0,0.08);">
        <!-- Header -->
        <tr>
          <td align="center" style="padding:35px 30px 25px 30px;background-color:#3399cc;border-bottom:5px solid #2980b9;border-top-left-radius:12px;border-top-right-radius:12px;">
            <img src="${logoUrl}" alt="Listernaut Logo" width="180" style="display:block;filter:brightness(0) invert(1);" />
          </td>
        </tr>

        <!-- Welcome -->
        <tr><td class="content-padding" style="padding:35px 40px 25px 40px;">
          <h1 style="font-size:32px;line-height:40px;margin:0 0 20px 0;text-align:center;">Welcome to Listernaut, ${name}!</h1>
          <p style="margin:0 0 25px 0;font-size:16px;line-height:26px;color:#555;text-align:center;">
            We're excited to help you get started. This guide will walk you through the essential first steps.
          </p>

          <table role="presentation" style="width:100%;background-color:#f7f9fa;border:1px solid #e8eef3;border-radius:8px;">
            <tr><td style="padding:20px;">
              <p style="margin:0;font-size:15px;line-height:24px;color:#333;">
                <strong>Your Email:</strong>
                <span style="font-family:'Courier New',monospace;background-color:#e8eef3;padding:4px 10px;border-radius:4px;border:1px solid #dce4eb;">${email}</span><br>
                <span style="font-size:13px;color:#666;display:block;margin-top:8px;">Use this email address when logging in to your Listernaut account.</span>
              </p>
            </td></tr>
          </table>
        </td></tr>

        <!-- Divider -->
        <tr><td style="padding:0 40px;"><div style="border-bottom:1px solid #e8eef3;"></div></td></tr>

        <!-- Training -->
        <tr><td class="content-padding" style="padding:35px 40px;text-align:center;">
          <h2 style="font-size:24px;line-height:32px;margin:0 0 15px 0;">Book Your Onboarding Session</h2>
          <p style="margin:0 0 20px 0;font-size:18px;line-height:26px;font-weight:bold;color:#d9534f;">
            Schedule a FREE training session — we’re constantly improving with new features and updates.
          </p>
          <a href="https://outlook.office.com/bookwithme/user/8db9abf233d84ec3827e4e7798ca1934@listernaut.com/meetingtype/QRbr1Ecan0Gkeo_aLMylPA2?anonymous&ismsaljsauthenabled&ep=mcard"
             class="button-link" style="background-color:#e74c3c !important;">Schedule Your FREE Training Now</a>
        </td></tr>

        <tr><td style="padding:0 40px;"><div style="border-bottom:1px solid #e8eef3;"></div></td></tr>

        <!-- Sites -->
        <tr><td class="content-padding" style="padding:35px 40px;text-align:center;">
          <h2 style="font-size:24px;line-height:32px;margin:0 0 30px 0;">Signup For Our Sites</h2>
          <div style="display:flex;justify-content:center;align-items:flex-start;gap:40px;flex-wrap:wrap;">
            <div class="column" style="flex:1;min-width:250px;max-width:300px;text-align:center;">
              <h3 style="font-size:20px;color:#3498db;margin:0 0 5px 0;">Explorer</h3>
              <p style="margin:0 0 15px 0;font-size:15px;color:#555;line-height:22px;">
                Fast and efficient cataloging with AI and Barcode lookups.
              </p>
              <a href="https://explorer.listernaut.com/" style="font-size:15px;color:#007bff;text-decoration:underline;font-weight:600;">Go to Explorer →</a>
            </div>
            <div class="column" style="flex:1;min-width:250px;max-width:300px;text-align:center;">
              <h3 style="font-size:20px;color:#3498db;margin:0 0 5px 0;">Listernaut</h3>
              <p style="margin:0 0 15px 0;font-size:15px;color:#555;line-height:22px;">
                Admin account setup and Shopify Ecommerce Launching.
              </p>
              <a href="https://beta.listernaut.com/#" style="font-size:15px;color:#007bff;text-decoration:underline;font-weight:600;">Go to Listernaut →</a>
            </div>
          </div>
        </td></tr>

        <!-- Demo -->
        <tr><td style="padding:25px 30px;text-align:center;background-color:#eafaf1;">
          <h2 style="font-size:24px;line-height:32px;margin:0 0 10px 0;color:#2c3e50;">Want a Demo For Your Team?</h2>
          <p style="margin:0 0 20px 0;font-size:16px;color:#555;line-height:24px;">
            We'll run you through a quick 15–30 minute demo of our software.
          </p>
          <a href="https://outlook.office.com/bookwithme/user/8db9abf233d84ec3827e4e7798ca1934@listernaut.com/meetingtype/QRbr1Ecan0Gkeo_aLMylPA2?anonymous&ismsaljsauthenabled&ep=mcard"
             class="button-link" style="background-color:#2ecc71 !important;">Book a Demo</a>
        </td></tr>

        <!-- Resources -->
        <tr><td class="content-padding" style="padding:35px 40px;text-align:center;">
          <h2 style="font-size:24px;line-height:32px;margin:0 0 20px 0;">Resources & Direct Contacts</h2>
          <p style="margin:0 0 35px 0;">
            <a href="https://listernaut.com/pages/e-commerce-tutorials" class="button-link" style="background-color:#95a5a6 !important;">View Tutorials</a>
          </p>
          <table role="presentation" style="width:100%;max-width:350px;margin:0 auto;">
            <tr><td style="padding-bottom:25px;text-align:center;">
              <a href="https://outlook.office.com/bookwithme/user/8db9abf233d84ec3827e4e7798ca1934@listernaut.com/meetingtype/QRbr1Ecan0Gkeo_aLMylPA2?anonymous&ismsaljsauthenabled&ep=mcard"
                 style="font-size:16px;color:#007bff;text-decoration:underline;font-weight:600;">Schedule Jeff Kaplan</a>
              <p style="font-size:14px;color:#7f8c8d;margin:6px 0 0 0;">Account Management & Sales</p>
            </td></tr>
            <tr><td style="padding-bottom:25px;text-align:center;">
              <a href="https://outlook.office.com/bookwithme/user/8db9abf233d84ec3827e4e7798ca1934@listernaut.com/meetingtype/QRbr1Ecan0Gkeo_aLMylPA2?anonymous&ismsaljsauthenabled&ep=mcard"
                 style="font-size:16px;color:#007bff;text-decoration:underline;font-weight:600;">Schedule Logan Weaver</a>
              <p style="font-size:14px;color:#7f8c8d;margin:6px 0 0 0;">Integration & Technical Support</p>
            </td></tr>
            <tr><td style="text-align:center;">
              <a href="https://outlook.office.com/bookwithme/user/8db9abf233d84ec3827e4e7798ca1934@listernaut.com/meetingtype/QRbr1Ecan0Gkeo_aLMylPA2?anonymous&ismsaljsauthenabled&ep=mcard"
                 style="font-size:16px;color:#007bff;text-decoration:underline;font-weight:600;">Schedule Bert Leffel</a>
              <p style="font-size:14px;color:#7f8c8d;margin:6px 0 0 0;">Partnerships & Enterprise Sales</p>
            </td></tr>
          </table>
        </td></tr>

        <!-- Footer -->
        <tr><td style="padding:25px 40px;text-align:center;background-color:#ecf0f1;font-size:13px;color:#888;">
          <p>If you have any questions, reach out at <a href="mailto:info@listernaut.com" style="color:#3498db;">info@listernaut.com</a>.</p>
          <p style="margin:10px 0 0 0;">&copy; ${new Date().getFullYear()} Listernaut. All rights reserved.</p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`;

      await axios.post(`${config.API_BASE_URL}/send-email`, {
        to: email,
        bcc: ["jeff@listernaut.com", "bert@listernaut.com", "mark@listernaut.com"],
        subject: `Welcome to Listernaut - ${name}`,
        html: htmlTemplate,
        fromName: "Listernaut",
      });

      showToast("Signup successful! Welcome email sent.", "success");
    } catch (err) {
      const status = err?.response?.status;
      const apiError = err?.response?.data?.error;

      if (status === 409) {
        setError("This email is already registered. Please log in instead.");
        showToast(
          "This email is already registered. Please log in instead.",
          "warning"
        );
      } else if (status === 429) {
        setError(apiError || "Signup already in progress. Please wait.");
        showToast(apiError || "Signup already in progress. Please wait.", "warning");
      } else {
        setError(apiError || "Failed to sign up. Please check your details.");
        showToast(apiError || "Failed to sign up. Please check your details.", "error");
      }
      console.error("Signup error:", apiError || err.message);
    } finally {
      setIsSigningUp(false);
    }
  };

  return (
    <>
      <form className="flex flex-col space-y-4" onSubmit={handleSignup}>
        <div>
          <label className="block text-slate-200  mb-1 text-sm">
            Full Name<span className="text-rose-400">*</span>
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-4 py-2.5 rounded-full border border-slate-600 bg-slate-900/60 text-slate-50 placeholder-slate-400 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/50 outline-none text-sm transition"
            placeholder="Enter your full name"
          />
        </div>
        <div>
          <label className="block text-slate-200  mb-1 text-sm">
            Email<span className="text-rose-400">*</span>
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2.5 rounded-full border border-slate-600 bg-slate-900/60 text-slate-50 placeholder-slate-400 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/50 outline-none text-sm transition"
            placeholder="you@example.com"
          />
        </div>
        <div>
          <label className="block text-slate-200  mb-1 text-sm">
            Password<span className="text-rose-400">*</span>
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2.5 rounded-full border border-slate-600 bg-slate-900/60 text-slate-50 placeholder-slate-400 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/50 outline-none text-sm transition"
            placeholder="Create a secure password"
          />
        </div>
        <div>
          <label className="block text-slate-200  mb-1 text-sm">
            Phone Number <span className="text-slate-400">(optional)</span>
          </label>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="w-full px-4 py-2.5 rounded-full border border-slate-600 bg-slate-900/60 text-slate-50 placeholder-slate-400 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/50 outline-none text-sm transition"
            placeholder="Enter your phone number"
          />
        </div>
        <div>
          <label className="block text-slate-200  mb-1 text-sm">
            Company Name <span className="text-slate-400">(optional)</span>
          </label>
          <input
            type="text"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            className="w-full px-4 py-2.5 rounded-full border border-slate-600 bg-slate-900/60 text-slate-50 placeholder-slate-400 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/50 outline-none text-sm transition"
            placeholder="Enter your company name"
          />
        </div>

        <div>
          <label className="block text-slate-200  mb-1 text-sm">
            Type <span className="text-slate-400">(optional)</span>
          </label>
          <select
            value={signupType}
            onChange={(e) => setSignupType(e.target.value)}
            className="w-full px-4 py-2.5 rounded-full border border-slate-600 bg-slate-900/60 text-slate-50 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/50 outline-none text-sm transition"
          >
            <option value="">Select a type</option>
            <option value="Reseller">Reseller</option>
            <option value="Bargain Hunter">Bargain Hunter</option>
            <option value="Shipping">Shipping</option>
            <option value="Shipping Reseller">Shipping Reseller</option>
            <option value="Estate Saler">Estate Saler</option>
            <option value="Facebook seller">Facebook seller</option>
            <option value="Home Business">Home Business</option>
            <option value="Contractors">Contractors</option>
          </select>
        </div>

        <div>
          <label className="block text-slate-200  mb-1 text-sm">
            How did you hear about us? <span className="text-slate-400">(optional)</span>
          </label>
          <select
            value={heardFrom}
            onChange={(e) => {
              const v = e.target.value;
              setHeardFrom(v);
              if (v !== "Referral") setReferralSourceName("");
            }}
            className="w-full px-4 py-2.5 rounded-full border border-slate-600 bg-slate-900/60 text-slate-50 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/50 outline-none text-sm transition"
          >
            <option value="">Select an option</option>
            <option value="Google">Google</option>
            <option value="Facebook">Facebook</option>
            <option value="Instagram">Instagram</option>
            <option value="LinkedIn">LinkedIn</option>
            <option value="YouTube">YouTube</option>
            <option value="TikTok">TikTok</option>
            <option value="Email">Email</option>
            <option value="Other">Other</option>
            <option value="Referral">Referral</option>
          </select>
        </div>

        {heardFrom === "Referral" && (
          <div>
            <label className="block text-slate-200  mb-1 text-sm">
              Referral source name <span className="text-rose-400">*</span>
            </label>
            <input
              type="text"
              value={referralSourceName}
              onChange={(e) => setReferralSourceName(e.target.value)}
              className="w-full px-4 py-2.5 rounded-full border border-slate-600 bg-slate-900/60 text-slate-50 placeholder-slate-400 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/50 outline-none text-sm transition"
              placeholder="Who referred you?"
            />
          </div>
        )}

        <div className="flex items-center justify-between text-xs text-slate-300">
          <button
            type="button"
            onClick={() => setTermsOpen(true)}
            className="underline underline-offset-2 hover:text-indigo-200"
          >
            View Terms & Conditions
          </button>
          <span className="text-[0.75rem]">
            Status:{" "}
            <span
              className={
                termsAccepted ? "text-emerald-300 " : "text-rose-300"
              }
            >
              {termsAccepted ? "Accepted" : "Not accepted"}
            </span>
          </span>
        </div>

        {error && (
          <p className="text-rose-300 text-xs mt-1 leading-snug">{error}</p>
        )}

        <button
          type="submit"
          disabled={isSigningUp}
          className={`w-full px-4 py-2.5 mt-2 bg-gradient-to-r from-indigo-500 to-indigo-400 text-white rounded-full  text-sm shadow-md hover:shadow-lg transition-all ${isSigningUp
            ? "opacity-60 cursor-not-allowed"
            : "hover:from-indigo-400 hover:to-indigo-300"
            }`}
        >
          {isSigningUp ? "Signing up..." : "Signup"}
        </button>
      </form>

      {/* Terms & Conditions Modal */}
      <Dialog
        open={termsOpen}
        onClose={() => setTermsOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: dialogPaperSx }}
      >
        <DialogTitle
          sx={{
            px: 3,
            py: 2.5,
            pb: 1.5,
            fontWeight: 700,
            fontSize: "1.05rem",
            color: "#ffffff",
            background: "linear-gradient(to right, #333999, #5555bb)",
            borderTopLeftRadius: "1.25rem",
            borderTopRightRadius: "1.25rem",
          }}
        >
          Terms & Conditions
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            maxHeight: "60vh",
            overflowY: "auto",
            px: 3,
            pt: 2.5,
            pb: 2,
            background:
              "linear-gradient(to bottom right, #f9fafb, #edf2ff, #eef2ff)",
          }}
        >
          <TermsAndConditions />
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            py: 2,
            backgroundColor: "rgba(255,255,255,0.95)",
            borderTop: "1px solid rgba(226,232,240,0.9)",
          }}
        >
          <Button
            onClick={() => {
              setTermsAccepted(false);
              setTermsOpen(false);
            }}
            sx={{
              textTransform: "none",
              borderRadius: "999px",
              px: 2.5,
              fontWeight: 500,
              color: "#4b5563",
            }}
          >
            Reject
          </Button>
          <Button
            onClick={() => {
              setTermsAccepted(true);
              setTermsOpen(false);
              showToast("Terms & Conditions accepted.", "success");
            }}
            sx={{
              textTransform: "none",
              borderRadius: "999px",
              px: 2.75,
              fontWeight: 600,
              background: "linear-gradient(to right, #333999, #5555bb)",
              color: "#ffffff",
              boxShadow: "0 10px 25px rgba(15,23,42,0.25)",
              "&:hover": {
                background: "linear-gradient(to right, #2a2a7a, #4444aa)",
                boxShadow: "0 12px 30px rgba(15,23,42,0.35)",
              },
            }}
          >
            Accept
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LandingPage;
